import { Container } from '@material-ui/core';
import React from 'react';

const Payment = () => {
    return (
        <Container>
            <h1>Payment Options Coming Soon</h1>
            <img style={{ width: "40%" }} src="https://image.freepik.com/free-vector/payment-information-concept-illustration_114360-2886.jpg" alt="" />
        </Container>
    );
};

export default Payment;